import React, { FC, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { RenderImage } from "go-app/components/ImageRenderer/ListImageName";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { PurchaseReceiveApi } from "../../../../../../../../../../services/Api/Organization/types";
import { PurchaseContext } from "../../pages/Preview";

interface Props {
	receive: PurchaseReceiveApi;
	onHide: () => void;
	isShown: boolean;
}

const PurchaseReceiveDetailsModal: FC<Props> = ({ receive, onHide, isShown }) => {
	const { t } = useTranslation();
	const { purchase } = useContext(PurchaseContext);

	const totalQuantity = receive.items.map((item) => item.quantity).reduce((acc, cur) => acc + cur, 0);

	return (
		<Modal onHide={onHide} show={isShown} className="purchase-receive-details-modal">
			<Modal.Header closeButton>
				<Modal.Title>{t("modules.purchase.field.receive_details.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="details-box">
					<RenderImage data={{ color: "#FF9900" }} showColor date={purchase.purchased_at} />
					<div className="d-flex flex-column ms-2">
						<h4>{receive.number}</h4>
						<span className="mb-1">
							{`${t("common.word.reference_number")}: ${receive?.reference_number ?? "-"}`}
						</span>
						<div>
							<small>{FormatDate(receive?.received_at)}</small>
							<small>
								{t("common.word.quantity")}: {totalQuantity.toFixed(5)}
							</small>
						</div>
					</div>
				</div>
				<table className="table table-preview mt-4">
					<thead>
						<tr>
							<th>
								{t("lib:common.word.name")} / {t("common.word.comment.title")}
							</th>
							<th className="text-end">{t("common.word.quantity")}</th>
						</tr>
					</thead>
					<tbody>
						{receive?.items?.map((item, index) => (
							<tr key={`receive-item-${index}`}>
								<td>
									<div className="d-flex flex-column">
										<span>{item?.product_name || "-"}</span>
										<small className="text-muted font-weight-bold">{item?.comment || "-"}</small>
									</div>
								</td>
								<td className="text-end align-text-top">
									{item?.quantity ? item.quantity.toFixed(5) : "-"}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onHide} variant="light">
					{t("lib:common.action.close")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default PurchaseReceiveDetailsModal;
